import { defineComponent as d, computed as o, openBlock as s, createElementBlock as i, createElementVNode as t, toDisplayString as n, createCommentVNode as f, normalizeStyle as h, createStaticVNode as p } from "vue";
const _ = ["viewBox"], m = /* @__PURE__ */ t("mask", { id: "a8fb628f-7bfa-45bf-8259-dcee81d915bb" }, [
  /* @__PURE__ */ t("circle", {
    cx: "256",
    cy: "256",
    r: "256",
    fill: "#fff"
  })
], -1), g = { mask: "url(#a8fb628f-7bfa-45bf-8259-dcee81d915bb)" }, k = { key: 0 }, u = /* @__PURE__ */ p('<path fill="#d80027" d="m0 166.9 253-31.8 259 31.8v178l-257.5 37.4L0 345z"></path><path fill="#338af3" d="M0 0h512v166.9H0z"></path><path fill="#6da544" d="M0 344.9h512V512H0z"></path><g fill="#eee"><path d="M261.6 328.2a72.3 72.3 0 1 1 34.4-136 89 89 0 1 0 0 127.3 72 72 0 0 1-34.4 8.7z"></path><path d="m317.2 206 9.6 26.8 25.8-12.3-12.2 25.8 26.9 9.6-27 9.6 12.3 25.8-25.8-12.3-9.6 27-9.6-27-25.8 12.3 12.3-25.8-27-9.6 27-9.6-12.3-25.8 25.8 12.3z"></path></g>', 4), v = { fill: "none" }, b = ["r"], y = /* @__PURE__ */ d({
  __name: "az",
  props: {
    flagName: {},
    strokeColor: { default: "#000" },
    strokeWidth: { default: 0 }
  },
  setup(r) {
    const e = r, a = o(() => 512 + 2 * e.strokeWidth), l = o(() => -e.strokeWidth), c = o(() => 256 + e.strokeWidth / 2);
    return (x, z) => (s(), i("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      class: "svg-circle-flags",
      viewBox: `${l.value} ${l.value} ${a.value} ${a.value}`
    }, [
      m,
      t("g", g, [
        e.flagName ? (s(), i("title", k, n(e.flagName), 1)) : f("", !0),
        u
      ]),
      t("g", v, [
        t("circle", {
          cx: "256",
          cy: "256",
          r: c.value,
          fill: "none",
          style: h({ stroke: e.strokeColor, strokeWidth: e.strokeWidth })
        }, null, 12, b)
      ])
    ], 8, _));
  }
});
export {
  y as default
};
//# sourceMappingURL=az-7ef53db5.js.map
